import {
	BufferGeometry,
	Float32BufferAttribute,
	HalfFloatType,
	LinearFilter,
	Mesh,
	NearestFilter,
	OrthographicCamera,
	Vector2,
	WebGLRenderTarget,
} from 'three';

import { lisa } from '../Lisa.js';
import MouseComputationMaterial from '../Materials/MouseComputation/MouseComputation.js';
import { EVENTS } from '../constants.js';

import { globalUniforms } from './uniforms.js';

class MouseComputation extends Mesh {
	#renderTarget1;
	#renderTarget2;
	#i = 0;
	#camera = new OrthographicCamera(-1, 1, 1, -1, 0, 1);

	constructor({ rtWidth = 64, rtHeight = 64 } = {}) {
		super();

		const rtOptions = {
			samples: 0,
			type: HalfFloatType,
			minFilter: NearestFilter,
			magFilter: NearestFilter,
		};

		this.#renderTarget1 = new WebGLRenderTarget(rtWidth, rtHeight, rtOptions);
		this.#renderTarget2 = new WebGLRenderTarget(rtWidth, rtHeight, rtOptions);

		this.geometry = this.#createGeometry();
		this.material = this.#createMaterial();

		lisa.state.on(EVENTS.RENDER, this.#render);
	}

	#createGeometry() {
		return new BufferGeometry()
			.setAttribute('position', new Float32BufferAttribute([-1, 3, 0, -1, -1, 0, 3, -1, 0], 3))
			.setAttribute('uv', new Float32BufferAttribute([0, 2, 0, 0, 2, 0], 2));
	}

	#createMaterial() {
		const material = new MouseComputationMaterial({
			uniforms: {
				// uDelta: globalUniforms.uDelta,
				// uScrollSpeed: globalUniforms.uScrollSpeed,

				tLast: { value: this.#renderTarget2.texture },

				uMouse: { value: new Vector2() },
				uSpeed: { value: 0.002 },
				uScroll: { value: 0 },
			},
			defines: {
				TEXEL_SIZE: 1 / this.#renderTarget1.width,
			},
		});

		return material;
	}

	#render = () => {
		if (this.#i++ % 2 === 0) {
			lisa.renderer.setRenderTarget(this.#renderTarget1);
			this.material.uniforms.tLast.value = this.#renderTarget2.texture;
		} else {
			lisa.renderer.setRenderTarget(this.#renderTarget2);
			this.material.uniforms.tLast.value = this.#renderTarget1.texture;
		}

		lisa.renderer.clear();
		lisa.renderer.render(this, this.#camera);
		lisa.renderer.setRenderTarget(null);
	};

	dipose() {
		lisa.state.off(EVENTS.RENDER, this.#render);
		this.#renderTarget1.dispose();
		this.#renderTarget2.dispose();

		// disposeMesh(this);
	}

	get uniforms() {
		return this.material.uniforms;
	}

	get renderTarget1() {
		return this.#renderTarget1;
	}

	get renderTarget2() {
		return this.#renderTarget2;
	}

	get texture() {
		return this.#renderTarget1.texture;
	}
}

export { MouseComputation };
